import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountMetricsInsightsDigitalWorkingHoursSummaryEntityMapper } from '../../../infrastructure/mappers/challenge-insights/account-metrics-insights-digital-working-hours-summary.entity.mapper';
import { GetAccountMetricsInsightsDigitalWorkingHoursSummaryRequestDto } from '../../dtos/challenge-insights/get-account-metrics-insights-digital-working-hours-summary.request.dto';
import { GetAccountMetricsInsightsDigitalWorkingHoursSummaryResponseDto } from '../../dtos/challenge-insights/get-account-metrics-insights-digital-working-hours-summary.response.dto';
import { GetAccountMetricsInsightsDigitalWorkingHoursSummaryQuery } from '../../queries/challenge-insights/get-account-metrics-insights-digital-working-hours-summary.query';

export class GetAccountMetricsInsightsDigitalWorkingHoursSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountMetricsInsightsDigitalWorkingHoursSummaryQuery,
    protected readonly mapper: AccountMetricsInsightsDigitalWorkingHoursSummaryEntityMapper
  ) {}

  async get(
    props: GetAccountMetricsInsightsDigitalWorkingHoursSummaryRequestDto
  ): Promise<GetAccountMetricsInsightsDigitalWorkingHoursSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountMetricsInsightsDigitalWorkingHoursSummaryController.get encountered an error ${error}`
      );
    }
  }
}
